import CustomerTypeList from "./CustomerTypeList";

const CustomerTypeSetupPage = () => <CustomerTypeList />;

export default CustomerTypeSetupPage;
